export default __webpack_public_path__ + "static/media/buick.a6fe1fad.svg";